import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './IdentificationTagsFiltersScreen.module.scss';
import Button from '../../../../../../common/components/button/Button';
import FormItem from '../../../../../../common/components/formItem/FormItem';
import { Col, Row } from 'react-flexbox-grid';
import { SelectValueLabel } from '../../../../../../common/types/SelectValueLabel';
import { Controller, useForm } from 'react-hook-form';
import Label from 'common/components/label/Label';
import Select from 'common/components/select/Select';
import UsersService from 'api/users/UsersService';


export interface Filters {
    userId?: string;
    allIn?: string
    page?: number;
    orderColumn?: string;
    orderBy?: string;
}

type Props = {
    filters: Filters;
    onChange: (filters: Filters) => void;
    onFilter: (filters: Filters) => void;
}

const IdentificationTagsFiltersScreen: React.FC<Props> = ({ filters, onChange, onFilter }: Props) => {
    const { t } = useTranslation();

    const form = useForm<Filters>({ shouldUnregister: false, shouldFocusError: true, defaultValues: filters });
    
    const [usersOptions, setUsersOptions] = useState<SelectValueLabel[]>([]);

    const getData = async () => {
         const users = await UsersService.catalog();
         setUsersOptions(users);
    }

    useEffect(() => {
        getData();
    }, []);

    const clearFilters = () => {
        form.reset();
        form.setValue('userId', null);
        onInputChange();
        onSubmit(form.getValues());
    }

    const onSubmit = (filters: Filters) => {
        onFilter(filters);
    }

    const onInputChange = () => {
        onChange(form.getValues());
    }

    return (
        <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className={styles.formContent}>
                <div>
                    <FormItem>
                        <Row>
                            <Col xs={12}>
                                <FormItem>
                                    <Label className={styles.bold}>{t('identification_tags.user')}</Label>
                                    <Controller
                                        render={({ onChange, value }) => {
                                            return (
                                                <Select
                                                    options={usersOptions}
                                                    isClearable
                                                    placeholder={t('identification_tags.user')}
                                                    onChange={(data: SelectValueLabel) => {
                                                        onChange(data?.value ?? null);
                                                        onInputChange();
                                                    }}
                                                    value={usersOptions.find(x => x.value === value) ? { label: usersOptions.find(x => x.value === value)?.label ?? '', value: value } : null}
                                                />
                                            );
                                        }}
                                        control={form.control}
                                        name="userId"
                                        defaultValue={form.getValues('userId')} />
                                </FormItem>
                            </Col>
                        </Row>
                    </FormItem>
                </div>
                <div className={styles.buttonsFooter}>
                    <FormItem>
                        <Button
                            text={t('common.clear')}
                            size={'normal'}
                            preset={'secondary'}
                            onClick={clearFilters}
                            type='reset' />
                        <Button
                            type='submit'
                            text={t('common.apply')}
                            size={'normal'}
                        />
                    </FormItem>
                </div>
            </div>
        </form>
    );
}

export default memo(IdentificationTagsFiltersScreen);